import { WarningIcon } from "@phosphor-icons/react/dist/csr/Warning";
import { PageTabsList } from "@volca/ui/components/ui/page-tabs-list";
import { Tabs, TabsTrigger } from "@volca/ui/components/ui/tabs";
import { useIsMobile } from "@volca/ui/hooks/use-mobile";
import { AttentionCount } from "@/app-shell";
import { useGetReviewQueue } from "./query";
import { useApTabs } from "./use-ap-tabs";
import { useForwardingEmptyState } from "./use-forwarding-empty-state";
import { AP_TAB, AP_TAB_LABEL, type ApTabValue, flattenPages } from "./utils";

// On a phone the nav column is in the drawer, so the page carries AP's tabs
// itself; on desktop the column beside the page lists them.
export const ApTabList = ({
  businessId,
  activeTab,
  onTabChange,
}: {
  businessId: string | null;
  activeTab: ApTabValue;
  onTabChange: (tab: ApTabValue) => void;
}) => {
  const isMobile = useIsMobile();
  const tabs = useApTabs();
  const { data: reviewQueue, hasNextPage } = useGetReviewQueue(businessId);
  const reviewCount = flattenPages(reviewQueue?.pages).length;
  const forwardingEmpty = useForwardingEmptyState(
    businessId,
    activeTab === AP_TAB.review,
  );

  if (!isMobile || forwardingEmpty) return null;

  return (
    <Tabs
      value={activeTab}
      onValueChange={(value) => onTabChange(value as ApTabValue)}
      className="shrink-0 gap-0"
    >
      <PageTabsList>
        {tabs.map(({ tab, warning }) => (
          <TabsTrigger key={tab} value={tab}>
            <span className="inline-flex items-center gap-1.5">
              {AP_TAB_LABEL[tab]}
              {tab === AP_TAB.review && reviewCount > 0 && (
                <AttentionCount
                  count={reviewCount}
                  isPartial={hasNextPage}
                  label="to review"
                />
              )}
              {warning && (
                <WarningIcon
                  className="size-4 shrink-0 text-warning"
                  aria-label={warning}
                  role="img"
                />
              )}
            </span>
          </TabsTrigger>
        ))}
      </PageTabsList>
    </Tabs>
  );
};
